import Vue from 'vue'
import App from './App.vue'
import i18n from "./i18n";
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'


import "./plugins/vueaxios";
import "./plugins/vueauth";
import "./plugins/vuemoment";
import "./plugins/vuemeta";
import "./plugins/vueobjectpath";
import "./plugins/vuelidate";
import "./plugins/vuerequestbuilder"
import "./plugins/vuelodash";
import "./plugins/vueclipboard";
import "./plugins/vueutils";



Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
